import { CloudinaryVideo } from "../Cloudinary";

interface Props {
  guideId: string;
  publicId: string;
}

export default function GuideProfileVideo({ guideId, publicId }: Props) {
  return (
    <div>
      <CloudinaryVideo
        style={{
          width: "100%",
          height: 567,
          objectFit: "contain",
        }}
        playsInline
        autoPlay
        controls
        src={{ url: publicId }}
        transformations={["w_375", "h_567", "c_fill"]}
      />
    </div>
  );
}
